import type { ReactNode } from "react";
import { Link } from "react-router-dom";

/**
 * Lets a shared primitive render a CLIENT-routed link without shoku-ui taking
 * a dependency on react-router.
 *
 * The primitives (EmptyState, and anything else that renders an `href` action)
 * fall back to a plain `<a>`; on a SPA that is a full page reload, which throws
 * away the session gate's in-memory state and costs a second of blank screen.
 */
export function routerLink({
  href,
  className,
  children,
}: {
  href: string;
  className: string;
  children: ReactNode;
}) {
  return (
    <Link to={href} className={className}>
      {children}
    </Link>
  );
}
